import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseLayer from "../../../core/BaseLayer";
import RasterModel from "../../../raster/models/rasterTile";
import RasterRgbModel from "../../../raster/models/rasterRgb";

var RasterTiffLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(RasterTiffLayer, _BaseLayer);

  var _super = _createSuper(RasterTiffLayer);

  function RasterTiffLayer() {
    var _this;

    _classCallCheck(this, RasterTiffLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", _this.layerType);

    return _this;
  }

  _createClass(RasterTiffLayer, [{
    key: "buildModels",
    value: function buildModels() {
      var _this2 = this;

      var model = this.getModelType();
      this.layerModel = new model(this);
      this.layerModel.initModels(function (models) {
        _this2.dispatchModelLoad(models);
      });
    }
  }, {
    key: "rebuildModels",
    value: function rebuildModels() {
      var _this3 = this;

      this.layerModel.buildModels(function (models) {
        _this3.dispatchModelLoad(models);
      });
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      if (this.layerSource.parser.type === 'rasterRgb') {
        return RasterRgbModel;
      } else {
        return RasterModel;
      }
    }
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      return {};
    }
  }]);

  return RasterTiffLayer;
}(BaseLayer);

export { RasterTiffLayer as default };